export const FORM_SLUGS = {
  COVID_19_RESPONSE_PLAN: 'federal-covid19-response-plan',
};

// TODO: Fix this the next time the file is edited.
// eslint-disable-next-line import/no-default-export
export default FORM_SLUGS;
